const isEnabled = (value) => value === true || value === 1 || value === '1' || value === 'true';

export const hasRegularMessage = (messages = []) => messages.some((message) =>
    ![message.isSystem, message.system, message.is_system].some(isEnabled) &&
    message.type !== 'system' &&
    (Boolean(message.text?.trim()) || Boolean(message.attachments?.length))
);
